/* globals $, alert, i18n, console, Rails, app */

$(function() {

    'use strict';

    var body = $('body'),
        timeout = null;

    // Popover
    body.popover({
        html: true,
        selector: '[data-toggle="popover"]'
    });

    // Prevent double click
    body.on('click', 'a[data-remote="true"]', function(e){
        var $el = $(this);
        if($el.data('clicked')){
            e.preventDefault();
            e.stopPropagation();
        }else{
            $el.data('clicked', true);
            window.setTimeout(function(){
                $el.removeData('clicked');
            }, 1500);
        }
    });

    // Disable submit button if clicked
    body.on('click', "button[type='submit']", function(e){

        var form = $(this).closest('form'),
            formElement = form[0];

        if(!formElement.checkValidity()) {

            formElement.querySelector('button[type="submit"]').click();
            return;

        }

        e.preventDefault();

        console.info('Intercepting form submission to avoid multiple submissions.');

        form.find("button[type='submit']").attr('disabled', true);

        form.append($('<input/>', {
            type: 'hidden',
            name: this.name,
            value: this.value
        }));

        // Call form submit on form prototype to avoid issues if buttons are named submit

        if(formElement.dataset.remote) {
            Rails.fire(formElement, 'submit');
        } else {
            HTMLFormElement.prototype.submit.call(formElement);
        }

    });

    body.on('change', '.checkbox-toggle', function() {
        $('input:checkbox.toggable').prop('checked', $(this).prop('checked'));
    });

    body.on('change', 'form.filter input[name!=\'query\']:not(".no-trigger"), form.filter select:not(".no-trigger"), input.auto-submission', function() {

        var form = $(this.form);

        form.submit();
        toggleFilters(form, true);

    });

    body.on('keydown', 'form.filter input[name=\'query\']', function(e) {

        if(e.keyCode !== 13) {
            return;
        }

        var form = $(this.form);

        form.submit();
        toggleFilters(form, true);

    });

    body.on('ajax:complete', 'form.filter', function() {

        toggleFilters($(this), false);

        var event = new CustomEvent('sbw:filter-updated');

        this.dispatchEvent(event);

    });

    checkSidebarState();

    /* Handle modal presets */

    body.on('modal:show', function(e) {

        var trigger = e.detail.triggerElement;

        if(!trigger) {
            return;
        }

        var presets = $(trigger).data('presets');

        if(!presets) {
            return;
        }

        Object.keys(presets).forEach(function (key) {

            var field = modal.find('[name="' + key + '"]');

            if(field) {
                field.val(presets[key]);
            }

        });

    });

    /* Check selected filters */
    var filters = $('.filter-box');

    $.each(filters, function(i, filter){
        change_select_bg(filter);
    });

    body.on('change', '.filter-box', function() {
        change_select_bg($(this).context);
    });

    body.on('change', 'input[name="contact[is_company]"]', function() {

        var contactPerson = $('#contact_person'),
            contactCompany = $('#contact_company');

        if($(this).prop( "checked" )) {

            contactPerson.addClass('hidden');
            contactCompany.removeClass('hidden');

        } else {

            contactPerson.removeClass('hidden');
            contactCompany.addClass('hidden');

        }

    });

    body.on('change', 'input[name="address[is_po_box]"]', function() {

        var poBox = $('#po_box'),
            street = $('#street');

        if($(this).prop( "checked" )) {

            street.addClass('hidden');
            poBox.removeClass('hidden');

        } else {

            poBox.addClass('hidden');
            street.removeClass('hidden');

        }

    });

    body.on('change', '.address-status', function() {

        $.ajax({
            url: '/addresses/' + $(this).data('address-id') + '/status',
            type: 'PATCH',
            dataType: 'json',
            data: {
                status: $(this).val()
            }
        });

    });

    /* Submit form on access key strg + enter */
    body.on('keydown', '.accesskey-submit', function(e) {
        if ((e.ctrlKey || e.metaKey) && (e.keyCode === 13 || e.keyCode === 10)) {
            $(this).closest('form').submit();
        }
    });

    body.on('change', '.no_contact_address_available', function() {

        var addressBox = $('.address-box')[0].selectize;

        if($(this).prop( "checked" )) {

            addressBox.setValue('', true);
            addressBox.clear();
            addressBox.disable();

            $('.address-box-target').val('');

        } else {
            addressBox.enable();
        }

    });

    body.on('click', '.btn-merge-contact', function(e) {

        e.preventDefault();
        var target = $(this),
            container = $('#merge-contact'),
            body = container.find('.box-body'),
            tbody = body.find('.merge-body'),
            tbodylength = tbody.children().length,
            row = target.closest('tr'),
            contactId = row.data('contact-id');

        if(tbody.children('tr[data-contact-id="'+contactId+'"]').length > 0) {
            alert(i18n.t('messages.merge_contact.duplicate_contact'));
            return;
        }

        if(tbodylength === 2) {
            alert(i18n.t('messages.merge_contact.maximum_exceeded'));
            return;
        }

        if(tbodylength === 1) {
            container.find('button[type="submit"]').prop('disabled', false);
        }

        var clonedRow = row.clone();
        clonedRow.find('>td:first-child').remove();
        clonedRow.find('>td:last-child').remove();

        clonedRow.append(function() {
            var td = document.createElement('td'),
                button = document.createElement('a'),
                icon = document.createElement('i');

            td.classList.add('controls');

            button.classList.add('btn', 'btn-danger', 'btn-sm');
            button.addEventListener('click', function(e){
                e.preventDefault();
                td.parentElement.remove();
                container.find('button[type="submit"]').prop('disabled', true);
                if(tbody.children('tr').length === 0) {
                    container.addClass('hide');
                }
            }, false);

            icon.classList.add('fa', 'fa-trash');

            button.appendChild(icon);
            td.appendChild(button);

            return td;

        });

        clonedRow.find('>td:first-child').append('<input type="hidden" name="contact_id[]" value="'+contactId+'" />');

        tbody.append(clonedRow);

        container.removeClass('hide');
    });

    body.on('click', '#merge-contact-table > thead a.check-all', function(e) {

        e.preventDefault();

        var index = this.parentElement.cellIndex + 1;

        $('td:nth-child('+ index +') input').prop('checked', true);

    });

    $('.user-statistic-table').stickyTableHeaders({
        fixedOffset: $('header')
    });

    // Scope filter handling

    body.on('click', 'button.scope-filter', function(e) {

        e.preventDefault();

        var parent = this.parentElement,
            input = parent.querySelector('input[type="hidden"]'),
            icon = parent.querySelector('i');


        var isActive = (input.value === 'true');

        if(isActive) {

            input.value = 'false';
            icon.classList.replace('fa-check-square-o', 'fa-square-o');
            this.classList.remove('active');

        } else {

            input.value = 'true';
            icon.classList.replace('fa-square-o', 'fa-check-square-o');
            this.classList.add('active');

        }

        var form = $(this.form);

        form.submit();
        toggleFilters(form, true);

    });

    // Value filter handling

    $('.value-filter-operator').selectize();

    body.on('change', '.value-filter select', function() {

        var parent = this.parentElement,
            input = parent.querySelector('.value-filter-value'),
            hiddenInput = parent.querySelector('input[type="hidden"]'),
            form = $(this.form);

            hiddenInput.value = this.value + ';' + input.value;

            form.submit();
            toggleFilters(form, true);

    });

    body.on('keyup', '.value-filter input[type="text"]', function() {

        var parent = this.parentElement,
            operator = parent.querySelector('.value-filter-operator'),
            hiddenInput = parent.querySelector('input[type="hidden"]'),
            form = $(this.form);

        hiddenInput.value = operator.value + ';' + this.value;

        if(timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(function() {
            form.submit();
            toggleFilters(form, true);
        }, 500);

    });

    body.on('click', '.btn-outdated', function(e) {

        e.preventDefault();

        var btn = $(this),
            contactDatumId = btn.data('contact-data-id'),
            parentChildren = btn.parent().children(),
            link = parentChildren.eq(0),
            span = parentChildren.eq(1),
            isOutdated = span.hasClass('outdated');

        $.ajax({
            url: '/contact_data/' + contactDatumId + '/outdated',
            type: 'PATCH',
            dataType: 'json'
        });

        if(isOutdated) {
            span.addClass('hidden').removeClass('outdated');
            link.removeClass('hidden');
        } else {
            link.addClass('hidden');
            span.removeClass('hidden').addClass('outdated');
        }

    });

    // Initialize fancybox
    $('[data-fancybox]').fancybox({
        openEffect: 'elastic',
        closeEffect: 'elastic',
        autoSize: true,
        smallBtn: true,
        protect: true,
        iframe: {
            preload: false // fixes issue with iframe and IE
        }
    });

    // Initialize rating
    $('div.rating').each(function() {
        var locationId = $(this).data('location-id'),
            rating = $(this).data('rating'),
            width = $(this).data('width') || '20px',
            spacing = $(this).data('spacing') || '2px',
            readOnly = $(this).data('read-only') || false;

        $(this).rateYo({
            fullStar: true,
            rating: rating,
            starWidth: width,
            spacing: spacing,
            readOnly: readOnly,

            onSet: function (rating) {
                $.ajax({
                    url: '/locations/' + locationId + '/rate',
                    type: 'PATCH',
                    dataType: 'script',
                    data: {
                        rating: rating
                    },
                    success : function() {
                        alert('Bewertung wurde erfolgreich gespeichert.')
                    },
                    error: function() {
                        alert('Fehler: Bewertung konnte nicht gespeichert werden.')
                    }
                });
            }
        });
    });

});

function change_select_bg(filter) {

    'use strict';

    if (filter.value) {
        filter.style.setProperty('background-color', '#ffe8c5');
    } else {
        filter.style.removeProperty('background-color');
    }

}

function checkSidebarState() {

    'use strict';

    // Check sidebar state
    var initial_sidebar_collapse = $.parseJSON(localStorage.getItem('is_sidebar_collapse'));

    // check if local storage is set
    if(initial_sidebar_collapse === null) {
        initial_sidebar_collapse = false;
        localStorage.setItem('is_sidebar_collapse', initial_sidebar_collapse);
    }

    // check if sidebar is collapsed and set body class
    if(initial_sidebar_collapse === true) {
        $('body').addClass('sidebar-collapse');
    }

    // toggle sidebar-collapse state
    $('a.sidebar-toggle').on('click', function() {

        var is_sidebar_collapsed = $.parseJSON(localStorage.getItem('is_sidebar_collapse'));
        localStorage.setItem('is_sidebar_collapse', !is_sidebar_collapsed);

    });

}

function toggleFilters(form, disabled) {

    'use strict';

    form.find('input').prop('disabled', disabled);
    form.find('select').prop('disabled', disabled);
    form.find('button').prop('disabled', disabled);

    var icon = form.find('.search .btn i.fa');

    if(disabled) {

        icon.removeClass('fa-search');
        icon.addClass('fa-refresh fa-spin');

    } else {

        form.find('.selectize-input input').focus();
        icon.removeClass('fa-refresh fa-spin');
        icon.addClass('fa-search');

    }

    if(form.find('.search-box')[0] !== undefined) {

        var searchBox = form.find('.search-box')[0].selectize;

        if(disabled) {
            searchBox.disable();
        } else {

            searchBox.enable();
            searchBox.focus();

        }

    }

}
